require('./vendor/jsonpath')

jsonpath.scope({parseInt: parseInt, parseFloat: parseFloat})

export default {
  delim_value : function(value){
    var delim = parseFloat(value).toString().split(".");
    delim[0] = delim[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return delim.join(".");
  },

  round_value : function(value, decimals){
    if(!value) {
      value = 0;
    }

    if(decimals == 0)
      return parseInt(value);

    if(!decimals)
      decimals = Math.abs(value) < 0.0001 ? 10 : 5;

    value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
    return value;
  },

  ledger_time_to_unix : function(t){
    return (t + 946684800)*1000;
  },

  // TODO look into importing / using vue components here (?)
  transform_ledger_json : function(j){
    function ledger_link(l){
      var a = document.createElement("a");
          a.setAttribute('href', '/ledger/' + l);
          a.appendChild(document.createTextNode(l));
      return a;
    }

    function account_link(acct){
      var a = document.createElement("a");
          a.setAttribute('href', '/account/' + acct);
          a.appendChild(document.createTextNode(acct));
      return a;
    }

    function tx_link(tx){
      var a = document.createElement("a");
          a.setAttribute('href', '/tx/' + tx);
          a.appendChild(document.createTextNode(tx));
      return a;
    }

    function humanize_ledger_time(time){
      return new Date(this.ledger_time_to_unix(time));
    }

    // Converting the hex string into an escaped string,
    // so if the hex string is "a2b320", it will become "%a2%b3%20"
    function hex2bin(str){
     var i = 0, len = str.length, result = "";
    
     for(; i < len; i+=2)
        result += '%' + str.substr(i, 2);      
    
     return unescape(result);
    }

    ///

    jsonpath.apply(j, "$.inLedger", function(val){
      return ledger_link(val);
    });

    jsonpath.apply(j, "$.ledger_index", function(val){
      return ledger_link(val);
    });

    jsonpath.apply(j, "$.PreviousTxnLgrSeq", function(val){
      return ledger_link(val);
    });

    ///

    jsonpath.apply(j, "$..Account", function(val){
      return account_link(val);
    });

    jsonpath.apply(j, "$..Owner", function(val){
      return account_link(val);
    });

    jsonpath.apply(j, "$..Destination", function(val){
      return account_link(val);
    });

    jsonpath.apply(j, "$..issuer", function(val){
      return account_link(val);
    });

    ///

    jsonpath.apply(j, "$.transactions[*].hash", function(val){
      return tx_link(val);
    })

    ///

    jsonpath.apply(j, "$.close_time", function(val){
      return humanize_ledger_time.bind(this)(val);
    }.bind(this));

    jsonpath.apply(j, "$.parent_close_time", function(val){
      return humanize_ledger_time.bind(this)(val);
    }.bind(this));

    jsonpath.apply(j, "$..CancelAfter", function(val){
      return humanize_ledger_time.bind(this)(val);
    }.bind(this));

    jsonpath.apply(j, "$..FinishAfter", function(val){
      return humanize_ledger_time.bind(this)(val);
    }.bind(this));

    jsonpath.apply(j, "$..date", function(val){
      return humanize_ledger_time.bind(this)(val);
    }.bind(this));

    ///

    jsonpath.apply(j, "$..MemoData", function(val){
      return hex2bin(val);
    });

    jsonpath.apply(j, "$..MemoFormat", function(val){
      return hex2bin(val);
    });

    jsonpath.apply(j, "$..MemoType", function(val){
      return hex2bin(val);
    });

    return j;
  }
}
